import exExternal from '../../../external';

// ----------------------------------------------------------------------------

function close(element: HTMLElement): void {
    const bsAlert = exExternal.bootstrap.Alert.getInstance(element);

    if (bsAlert) {
        bsAlert.close();
        return;
    }

    element.remove();
}

// ----------------------------------------------------------------------------

export default close;
